import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers/integration.mapper';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import { Client } from '../types/clients.types';

export function mapClientFromDTO(raw: any): Client {
  return {
    ...raw,
    connectedIntegrations: ((raw.connectedIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
    ignoredIntegrations: ((raw.ignoredIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
  };
}
